



























































































import { Vue, Component, Prop } from "@/shared/vuepack";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import * as RouteNames from "@/employee/route-names";
import { InvestmentCustodian, HsabSsoDestination } from "@/shared/types";
import { isMobileApp } from "@/shared/mobileHelper";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useDrivewealthAccountMigrationStore } from "@/shared/store/drivewealthAccountMigration";
import { useUserStore } from "@/shared/store/user";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";

@Component({
  components: {
    ValueBadge,
    SsoDeepLink,
    HsabInvestmentRedirectPage
  }
})
export default class HsaSubMenu extends Vue {
  featureFlagStore = useFeatureFlagStore();
  custodianSettingsStore = useCustodianSettingsStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  hsabInvestmentsStore = useHsabInvestmentStore();
  bankAccountStore = useBankAccountStore();
  drivewealthAccountMigrationStore = useDrivewealthAccountMigrationStore();
  userStore = useUserStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  RouteNames = RouteNames;

  @Prop()
  userHasAnyNotionalAccounts: boolean;

  @Prop()
  showResourcesLinkUnderHsa: boolean;

  @Prop()
  showResourcesLinkUnderRoot: boolean;

  created (): void {
    this.investmentThresholdStore.loadInvestmentThresholds({});
  }

  get showDashboardLink (): boolean {
    const { Home, Dashboard } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Home] || this.custodianSettingsStore.disabledRoutes[Dashboard]) {
      return false;
    }

    return true;
  }

  get hsabDeepLinkDashboard () {
    return HsabSsoDestination.Dashboard;
  }

  get showInvestmentsLink () {
    if (!this.custodianSettingsStore.displayInvestmentsSection) {
      return false;
    }

    const { InvestmentAccountInfo } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[InvestmentAccountInfo]) {
      return false;
    }

    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank) {
      const hsabDrivewealthEnabled = (this.investmentThresholdStore.isDrivewealthInvestmentProvider &&
          this.featureFlagStore.flags.bend15244DisplayDrivewealthInvestmentForHSABUsers);

      return this.hsabInvestmentsStore.hsabInvestmentsEnabled || hsabDrivewealthEnabled;
    }

    return this.custodianSettingsStore.investmentCustodian !== InvestmentCustodian.Tda
        || this.featureFlagStore.flags.showTdaInvestmentLink;
  }

  get showLegacyHsabInvestmentsRedirectLink (): boolean {
    return (!this.featureFlagStore.flags.bend15244DisplayDrivewealthInvestmentForHSABUsers &&
        this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank &&
        this.hsabInvestmentsStore.hsabInvestmentsEnabled);
  }

  get showDrivewealthLink (): boolean {
    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank) {
      return this.featureFlagStore.flags.bend15244DisplayDrivewealthInvestmentForHSABUsers;
    }

    return true;
  }

  get investmentIcon (): string {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      return "fa-solid fa-arrow-up-right-from-square";
    }

    return "fa-solid fa-chart-area";
  }

  get showCashAccountLink (): boolean {
    const { CashBalance } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[CashBalance]) {
      return false;
    }

    return true;
  }

  get showProductScannerLink () {
    if (this.bankAccountStore.isBankAccountClosed) {
      return false;
    }

    return isMobileApp();
  }

  get showNewClaims (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses &&
        this.custodianSettingsStore.showHealthcareExpensesV2;
  }

  get showContributionsLink (): boolean {
    const { Contribution } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Contribution]) {
      return false;
    }

    return true;
  }

  get showContributionPlannerLink (): boolean {
    const { ContributionPlanner } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[ContributionPlanner]) {
      return false;
    }

    return true;
  }

}
